<template>
  <div class="styles" :class="{ 'styles-active': isOpen }">
    <div class="styles-title">{{ title }}</div>
    <span>
      <span class="add"
        ><custom-icon v-if="icon" :class-name="icon" :icon-color="isOpen ? '#d5e5ff' : '#083277'" @click="addStyle"
      /></span>
      <custom-icon
        :class-name="`${isOpen ? icons.ChevronUp : icons.ChevronDown}`"
        :icon-color="isOpen ? '#d5e5ff' : '#083277'"
      />
    </span>
  </div>
</template>
<script>
import { icons } from "../../../../utils/icons";
import CustomIcon from "../../../commons/CustomIcon.vue";
export default {
  components: { CustomIcon },
  props: ["title", "icon", "isOpen"],
  data() {
    return {
      icons: icons,
    };
  },
  methods: {
    addStyle(event) {
      event.stopPropagation();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";
.styles {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  width: 100%;
  padding: 0.2rem 1rem;
  color: @kk-color-primary-blue;
  font-weight: bold;
  &:not(&-active)&:hover {
    background-color: @kk-color-light-blue;
  }
  &-active {
    background-color: @kk-color-primary-blue;
    color: @kk-color-light-white;
  }
}
</style>
